import { get } from '@/services/get'
import { ApplicantInfo } from '@/types/application/applicant-info'

export function getApplicationsApplicantInfo(applicationId: string) {
  return get<ApplicantInfo>(`/applications/${applicationId}/applicant-info`)
}
